import { ReactComponent as BarrierBlockFilled } from './icons/barrier-block-filled.svg';
import { ReactComponent as BoltFilled } from './icons/bolt-filled.svg';
import { ReactComponent as Drop2Filled } from './icons/drop-2-filled.svg';
import { ReactComponent as GeothermalEnergyFilled } from './icons/geothermal-energy-filled.svg';
import { ReactComponent as LeafFilled } from './icons/leaf-filled.svg';
import { ReactComponent as RecycleFilled } from './icons/recycle-filled.svg';
import { ReactComponent as WindmillFilled } from './icons/windmill-filled.svg';
import { ReactComponent as WoodFilled } from './icons/wood-filled.svg';
import type { CategoryConfig } from './types';

export const categoryConfigMap: Record<string, CategoryConfig> = {
  fernwaerme: {
    label: 'Fernwärme',
    icon: BarrierBlockFilled,
  },
  abfallverwertungsanlage: {
    label: 'Abfallverwertungsanlage',
    icon: RecycleFilled,
  },
  altholzverwertungsanlagen: {
    label: 'Altholzverwertungsanlagen',
    icon: WoodFilled,
  },
  'biomethan-blockheizkraftwerke': {
    label: 'Biomethan-Blockheizkraftwerke',
    icon: LeafFilled,
  },
  grosswaermepumpe: {
    label: 'Großwärmepumpe',
    icon: WindmillFilled,
  },
  geothermie: {
    label: 'Geothermie',
    icon: GeothermalEnergyFilled,
  },
  klaerschlammverwertung: {
    label: 'Klärschlammverwertung',
    icon: Drop2Filled,
  },
  'power-2-heat': {
    label: 'Power-2-Heat',
    icon: BoltFilled,
  },
};
